import type { GeneratedMail, MailHistoryItem } from "../types";
import { displayDate, senderName } from "../utils";

interface MailListProps {
  currentMail: GeneratedMail;
  history: MailHistoryItem[];
  selectedVariantId: string;
  onSelect: (mail: GeneratedMail) => void;
}

export function MailList({ currentMail, history, selectedVariantId, onSelect }: MailListProps) {
  const past = [...history].reverse().slice(0, 9).map((item) => item.mail);
  const mails = [currentMail, ...past];
  return (
    <section className="mail-list-panel" aria-label="メール一覧">
      <div className="mail-list-toolbar">
        <strong>受信箱</strong>
        <span>{mails.length}件</span>
      </div>
      <div className="mail-list">
        {mails.map((mail, index) => (
          <button
            type="button"
            className={selectedVariantId === mail.variantId ? "mail-list-item is-selected" : "mail-list-item"}
            key={`${mail.variantId}-${index}`}
            onClick={() => onSelect(mail)}
          >
            <div className="mail-list-row">
              <strong>{senderName(mail)}</strong>
              <time>{displayDate(mail).slice(-5)}</time>
            </div>
            <div className="mail-list-subject">{mail.subject}</div>
            <div className="mail-list-preview">{mail.body.replace(/\s+/g, " ").slice(0, 44)}</div>
            {index === 0 && <span className="mail-pending-label">未処理</span>}
          </button>
        ))}
      </div>
    </section>
  );
}
